/** Redact bearer tokens from both direct links and URL-encoded OAuth return paths. */
export function redactPrivateUrl(value: string): string {
  return value.replace(/((?:\/|%2f)(?:shared|join))(?:#|%23)[a-f0-9]{64}/gi, '$1[private-link]');
}
export function redactPrivateEvent<T>(value: T): T {
  if (typeof value === 'string') return redactPrivateUrl(value) as T;
  if (Array.isArray(value)) return value.map(redactPrivateEvent) as T;
  if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, redactPrivateEvent(v)])) as T;
  return value;
}
